import { usePage } from '@inertiajs/vue3'

// Visitor-facing date/time formatting for the public surface. useCurrency()
// reads app_setting, which is shared only to signed-in CRM users — on public
// pages it silently falls back to en-US. Key off the server-shared public
// locale (PublicLocale concern) instead, with the visitor's browser locale
// as the fallback.
export function usePublicDate() {
  const page = usePage()
  const loc = () => page.props.locale || []

  function formatDate(dt, options = { day: 'numeric', month: 'short', year: 'numeric' }) {
    if (!dt) return '—'
    return new Date(dt).toLocaleDateString(loc(), options)
  }

  function formatTime(dt, options = { hour: '2-digit', minute: '2-digit' }) {
    if (!dt) return '—'
    return new Date(dt).toLocaleTimeString(loc(), options)
  }

  return { formatDate, formatTime }
}
